module.exports = __webpack_public_path__ + "static/media/blog8_big.50c1b47d.webp";